import { render, staticRenderFns } from "./TaskStatusType.vue?vue&type=template&id=05d0ffc0&scoped=true&"
import script from "./TaskStatusType.vue?vue&type=script&lang=js&"
export * from "./TaskStatusType.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatusType.vue?vue&type=style&index=0&id=05d0ffc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d0ffc0",
  null
  
)

export default component.exports